<template>
    <div class="col-12 mx-auto">
        <div class="loader" v-show="loading"></div>
        <page-title showTitle :title="$t('sideMenu.summaryFormsReport')"></page-title>
        <!-- <div class="row mt-3">
            {{ reportModel }}
        </div> -->
        <div class="row p-3">
            <div class="alert alert-secondary col-12 col-lg-6">
                <div class="d-flex flex-row pt-2">
                    <vs-radio v-for="filter in filterSettings"
                        :key="filter.id"
                        v-model="reportModel.type"
                        :vs-name="'activeFieldFilter' + _uid"
                        :vs-value="filter.id"
                        class="mx-2"
                    >
                        <span class="mr-1" v-cloak>{{ filter.text }}</span>
                    </vs-radio>
                </div>
            </div>
            <div class="alert alert-info col-12 col-lg-6">
                <div class="d-flex flex-row pt-2">
                    <vs-radio v-for="filter in surveyFilterSettings"
                        :key="filter.id"
                        v-model="reportModel.surveyType"
                        :vs-name="'surveyTypeFieldFilter' + _uid"
                        :vs-value="filter.id"
                        class="mx-2"
                    >
                        <span class="mr-1" v-cloak>{{ filter.text }}</span>
                    </vs-radio>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'formType' + _uid">Тип на формуляр</label>
                <multi-select
                    v-model="reportModel.formTypes"
                    load-by-parent-sort
                    :parent-sort="formTypeSort"
                    fieldName="Тип на формуляр"
                    :id="'formType' + _uid"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'pasticipationType' + _uid">Тип на участие</label>
                <multi-select
                    v-model="reportModel.participationTypes"
                    :api-url="`/api/participationType/getDropdownModels?isLecturerType=false`"
                    fieldName="Тип на участие"
                    :id="'pasticipationType' + _uid"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'participationStatus' + _uid">Статус на участие</label>
                <multi-select
                    v-model="reportModel.participationStatuses"
                    load-by-parent-sort
                    :parent-sort="participationStatusSort"
                    fieldName="Статус на участие"
                    :id="'participationStatus' + _uid"
                    :bindPopup="true"
                    :readonly="reportModel.surveyType === 0"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <date-range
                    :startTime.sync="reportModel.fromDate"
                    :endTime.sync="reportModel.toDate"
                    :format="customDateFormat"
                    :showTime="false"
                    startTitle="participationConfirmation.fromDate"
                    endTitle="participationConfirmation.toDate"
                    :required="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'directorate' + _uid"> {{ $t('administrativePosition.directorate') }} </label>
                <multi-select
                    v-model="reportModel.directorates"
                    load-by-parent-sort
                    :parent-sort="directorateSort"
                    :id="'directorate' + _uid"
                    :fieldName="$t('administrativePosition.directorate')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'activities' + _uid"> {{ $t('activity.title') }} </label>
                <multi-select
                    v-model="reportModel.activities"
                    :api-url="`/api/dropdown/GetActivities`"
                    :id="'activities' + _uid"
                    :fieldName="$t('activity.title')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'eventForms' + _uid"> {{ $t('registers.events.eventForms') }} </label>
                <multi-select
                    v-model="reportModel.eventForms"
                    load-by-parent-sort
                    :parent-sort="eventFormTypeSort"
                    :id="'eventForms' + _uid"
                    :fieldName="$t('registers.events.eventForms')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'eventProjects' + _uid"> {{ $t('registers.events.gridHeaders.eventProjectName') }} </label>
                <multi-select
                    v-model="reportModel.eventProjects"
                    :api-url="`/api/dropdown/GetProjects`"
                    :id="'eventProjects' + _uid"
                    :fieldName="$t('registers.events.gridHeaders.eventProjectName')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'targetAudience' + _uid"> {{ $t('registers.events.gridHeaders.eventAudience') }} </label>
                <auto-complete
                    v-model="reportModel.targetAudience"
                    api-url="/api/dropdown/EventTargetAudiences"
                    :id="'targetAudience' + _uid"
                    value-field="text"
                    text-field="text"
                    :fieldName="$t('registers.events.gridHeaders.eventAudience')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'fundingType' + _uid"> {{ $t('registers.events.gridHeaders.eventFundingType') }} </label>
                <multi-select
                    v-model="reportModel.fundingTypes"
                    load-by-parent-sort
                    :parent-sort="fundingTypeSort"
                    :id="'fundingType' + _uid"
                    value-field="text"
                    text-field="text"
                    :fieldName="$t('registers.events.gridHeaders.eventFundingType')"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'coordinator' + _uid">Координатор</label>
                <auto-complete
                    v-model="reportModel.coodinator"
                    api-url="/api/lectors/CoordinatorsDropdown"
                    :id="'coordinator' + _uid"
                    value-field="text"
                    text-field="text"
                    fieldName="Координатор"
                />
                <!-- <multi-select-search
                    v-model="reportModel.coodinator"
                    api-url="/api/lectors/CoordinatorsDropdown"
                    :id="'coordinator' + _uid"
                    value-field="fullName"
                    text-field="fullName"
                    :fieldName="$t('registers.events.gridHeaders.eventFundingType')"
                /> -->
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'lecturerType' + _uid">Тип преподавател</label>
                <multi-select
                    v-model="reportModel.lecturerTypes"
                    :api-url="`/api/participationType/getDropdownModels?isLecturerType=true`"
                    :id="'lecturerType' + _uid"
                    value-field="id"
                    text-field="text"
                    fieldName="Тип преподавател"
                    :bindPopup="true"
                />
            </div>
            <div class="form-group col-12 col-md-6 col-lg-4">
                <label class="font-weight-bold" :for="'lecturer' + _uid">Преподавател</label>
                <multi-select
                    v-model="reportModel.lecturers"
                    api-url="/api/lectors/LecturersDropdown"
                    :id="'lecturer' + _uid"
                    value-field="text"
                    text-field="text"
                    fieldName="Преподавател"
                />
            </div>
            <!-- <div
                v-if="reportModel.type === 1"
                class="form-group col-12 col-md-6 col-lg-4"
            >
                <label class="font-weight-bold">
                    Филтриране на "Въпроси с краен брой отговори (затворените въпроси)" за събития с участието на избраните преподаватели
                </label>
                <vs-checkbox
                    v-model="reportModel.closedQuestionsBySelectdLecturers"
                    style="justify-content: flex-start !important"
                />
            </div> -->
        </div>
        <!-- <expandable-details
            title="Разширени филтри"
        >
            <template #content>
            </template>
        </expandable-details> -->
        <div class="text-center mt-3 mb-5">
            <button type="button" class="btn btn-info" :disabled="loading" @click="generateReport">
                <i class="far fa-file-word"></i>
                {{ $t('buttons.summaryDataReport.btnText') }}
            </button>
            <button
                v-if="reportModel.type > 0"
                type="button" class="btn btn-success" :disabled="loading" @click="generateExcelReport">
                <i class="far fa-file-excel"></i>
                {{ $t('buttons.summaryDataReport.btnText') }}
            </button>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { NomenclatureParentBySort } from '@/models/enums';
import DateRange from '@/components/dateTimeRange/DateTimeRange_new';
import PageTitle from '@/components/common/PageTitle';
import MultiSelect from '@/components/dropdown/MultiSelect';
import AutoComplete from '@/components/dropdown/AutoComplete';
// import ExpandableDetails from '@/components/common/ExpandableDetails.vue';


export default {
        name: 'FormsSummaryReport',
        components: {
            DateRange,
            PageTitle,
            MultiSelect,
            AutoComplete,
            // ExpandableDetails
        },
        data() {
            return {
                loading: false,
                reportModel: {
                    type: 0,
                    surveyType: 2,
                    formTypes: [6728],
                    participationTypes: [3, 7, 8],
                    lecturerTypes: [],
                    closedQuestionsBySelectdLecturers: true,
                    fromDate: new Date(new Date().getFullYear(), 0, 1)
                },
                directorateSort: NomenclatureParentBySort.Directorate,
                fundingTypeSort: NomenclatureParentBySort.FundingType,
                eventFormTypeSort: NomenclatureParentBySort.EventForm,
                formTypeSort: NomenclatureParentBySort.FormType,
                participationStatusSort: NomenclatureParentBySort.ParticipationStatus,
                filterSettings: [
                    { id: 0, text: 'Всички', textEn: 'All' },
                    { id: 1, text: 'Въпроси с краен брой отговори (затворените въпроси)', textEn: 'Въпроси с краен брой отговори (затворените въпроси)' },
                    { id: 2, text: 'Оценки на преподавателите', textEn: 'Оценки на преподавателите' }
                ],
                surveyFilterSettings: [
                    { id: 0, text: 'Анонимни анкети', textEn: 'Anonymous surveys' },
                    { id: 1, text: 'Неанонимни анкети', textEn: 'Non-anonymous surveys' },
                    { id: 2, text: 'Всички', textEn: 'All' }
                ],
            };
        },
        computed: {
            ...mapGetters(['dateFormat', 'claims', 'notificationDuration']),
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
            hasFormSummaryRights() {
                return this.claims.formSurvey.read
                    || (this.eventClaims && this.eventClaims[EventClaims.EventFormManagement].read);
            },
        },
        methods: {
            generateReport() {
                if (!this.hasFormSummaryRights) {
                    this.$router.push(`/unauthorized`);
                }

                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.loading = true;
                        this.$http
                            .post("/api/formSummary/createSummaryReport", this.reportModel, {
                                responseType: "blob",
                            })
                            .then((response) => {
                                const blob = new Blob([response.data], {
                                    type: 'application/msword',
                                });
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute(
                                    "download",
                                    `SummaryReport.docx`
                                ); // or any other extension
                                document.body.appendChild(link);
                                link.click();
                            })
                            .catch((error) => {
                                this.$vs.notify({
                                    title: this.$t('buttons.summaryDataReport.btnText'),
                                    text: this.$helpers.errorText(error),
                                    color: "danger",
                                    time: this.notificationDuration,
                                });
                            }).finally(() => {
                                this.loading = false;
                            });
                    }
                });
            },
            generateExcelReport() {
                if (!this.hasFormSummaryRights) {
                    this.$router.push(`/unauthorized`);
                }

                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.loading = true;
                        this.$http
                            .post("/api/formSummary/createExcelSummaryReport", this.reportModel, {
                                responseType: "blob",
                            })
                            .then((response) => {
                                const blob = new Blob([response.data], {
                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                });
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute(
                                    "download",
                                    `SummaryReport.xlsx`
                                ); // or any other extension
                                document.body.appendChild(link);
                                link.click();
                            })
                            .catch((error) => {
                                this.$vs.notify({
                                    title: this.$t('buttons.summaryDataReport.btnText'),
                                    text: this.$helpers.errorText(error),
                                    color: "danger",
                                    time: this.notificationDuration,
                                });
                            }).finally(() => {
                                this.loading = false;
                            });
                    }
                });
            }
        }
    }
</script>
